var map = {
	"./Customers/VPC-IT.jpg": 948,
	"./Customers/VPC-banks.jpg": 949,
	"./Customers/VPC-innovation.jpg": 950,
	"./Customers/VPC-insurance.jpg": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1568;